import styled from 'styled-components';

export const Container = styled.div(({forForms}) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: forForms ? "none" : "center",
}));

export const TabButtonGroup = styled.div(({theme, activeIndex, tabCount, forForms}) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #D1DBE3",
    maxWidth: "336px", 
    marginBottom: "32px",
    position: "relative",
    overflow: "hidden",
    
    [theme.breakpoint.md()]: {
        maxWidth: forForms ? "384px" : "592px",
    },

    '&::before': {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: `${100 / tabCount}%`,
        height: "100%",
        backgroundColor: "#005FC8",
        transform: `translateX(${activeIndex * 100}%)`,
        transition: "transform 0.5s ease",
        zIndex: 1,
        borderRadius: "8px",
    }
}));

export const TabButton = styled.button(({isActive}) => ({
    display: "flex",
    flex: "1",
    justifyContent: "center",
    alignItems: "center",
    color: `${isActive ? '#fff' : '#005FC8'}`,
    backgroundColor: "transparent", 
    border: "none",
    padding: "12px 8px",
    cursor: "pointer",
    position: "relative",
    zIndex: 2,
    transition: "color 0.5s ease", 
}));

export const TabContent = styled.div(() => ({
    width: "100%"
}))

export const TabTitle = styled.p(({theme}) => ({
    fontSize: "14px",
    fontWeight: 500,
    [theme.breakpoint.md()]: {
        fontSize: "16px",
    }
}))

